import React, { FC, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components/macro'
import Lottie from 'react-lottie'
import purpleAnimation from '../../assets/animations/swaap-loader-purple.json'
import whiteAnimation from '../../assets/animations/swaap-loader-white.json'
import ClipLoader from 'react-spinners/ClipLoader'
import { lightTheme } from '../Themes'

export interface Props {
  size?: number
  padding?: string
  color?: 'purple' | 'white'
}

const purpleOptions = {
  loop: true,
  autoplay: true,
  animationData: purpleAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

const whiteOptions = {
  loop: true,
  autoplay: true,
  animationData: whiteAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

export const SwaapLoader: FC<Props> = ({
  size = 25,
  padding = '0rem',
  color,
}) => {
  // @ts-ignore
  const theme = useContext(ThemeContext)
  let options
  if (color === undefined) {
    options = theme === lightTheme ? purpleOptions : whiteOptions
  } else {
    options = color === 'white' ? whiteOptions : purpleOptions
  }

  return (
    <div style={{ display: 'flex', padding }}>
      <Lottie options={options} height={size} width={size} />
    </div>
  )
}

export const SwaapMediumLoader: FC<Props> = ({ size }) => {
  return <SwaapLoader size={60} padding={'1rem'} />
}

export const SwaapLargeLoader: FC<Props> = ({ size }) => {
  return <SwaapLoader size={100} padding={'2rem'} />
}

export function SimpleLoader(props: { size?: string }) {
  return (
    <ClipLoader
      color={'#888'}
      loading={true}
      size={props.size ? props.size : '0.75em'}
    />
  )
}
